import Vue from 'vue'
import '@/plugins/vuetify'
import VueMoment from 'vue-moment'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import authHelper from '@/helpers/auth'
import VueConfirmDialog from 'vue-confirm-dialog'
import './registerServiceWorker'

Vue.config.productionTip = false
Vue.use(VueMoment)

const version = require('../package.json').version
console.log({version})


authHelper.initInterceptors()

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')


Vue.use(VueConfirmDialog)
Vue.component('vue-confirm-dialog', VueConfirmDialog.default)
